import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { InvestigationSavedFilterResponseDto } from '../dtos/investigation-saved-filter-response.dto';

@Injectable({ providedIn: 'root' })
export class InvestigationPredefinedFiltersApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/investigations/predefined-filters`;

  public getPredefinedFilters(): Observable<InvestigationSavedFilterResponseDto[]> {
    return this._http.get<InvestigationSavedFilterResponseDto[]>(this._baseUrl);
  }
}
